import React from "react";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

export const AuthenticationGuard = ({ component }) => {
  const Component = withAuthenticationRequired(component, {
    onRedirecting: () => (
        <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
            }}
        >
          <CircularProgress size={80} />
        </Box>
    ),
  });

  return <Component />;
};
